<div class="_tutorialScreen">
    @if (content) {

    <img [ratio]="16/9"
         [dfImage]="content.mainImage"
         [fill]="true">
    <div class="fill z-2 _overlay"
         [style.opacity]="content.mainOverlayOpacity"
         [style.filter]="content.mainDarkMode ? 'invert(1)' : 'none'">
    </div>

    @switch (currentStep) {
    @case (EStepType.welcome) {
    <div class="wrap pos-absolute left-0 right-0 flex-column flex-middle z-3"
         [style.top]="content.mainScreenContentPosition + '%'"
         [style.transform]="'translateY(-50%)'">
        <img [ratio]="content.mainLogoRatio"
             [dfImage]="content.mainLogo"
             [width]="250">

        <multisite-simple-label class="block m-t-6"></multisite-simple-label>

        <button class="button-inline-2 italic m-t-2"
                [iCmsModalOpen]="multisiteModalId"
                type="button">{{'Edit' | translate}}</button>

        <div class="w-12 p-l-7 p-r-7 m-t-10">
            <button class="button w-12"
                    (click)="openWelcomeContent()">
                <span *iCms="'continueButtonCopy' of content"></span>
            </button>
        </div>

    </div>
    <button [class.hidden]="!isWelcomeContentVisible"
            [iCmsModalOpen]="multisiteModalId"
            class="b-a b-a-41 bg-col-5 p-a-1 b-radius-max pos-absolute top-4 right-4 z-3">
        <multisite-simple-label [onlyIcon]="true"></multisite-simple-label>
    </button>
    <div [class._hidden]="!isWelcomeContentVisible"
         class="_welcomeContent _hidden flex-column flex-middle p-a-10 center">
        <h3 class="h2"
            *iCms="'welcomeTitle' of content; content: 'html'"></h3>
        <p class="p2 m-t-2"
           *iCms="'welcomeDescription' of content; content: 'html'"></p>
        <button class="button w-12 m-t-10"
                (click)="changeStep(EStepType.slides)">
            <span *iCms="'welcomeButtonCopy' of content"></span>
        </button>
        <button class="button-inline-2 italic m-t-6"
                (click)="changeStep(EStepType.login)">
            <span *iCms="'skipButtonCopy' of content"></span>
        </button>
    </div>
    }
    @case (EStepType.slides) {
    <div class="height-100 flex-column pos-relative z-3 bg-col-51">
        <img [ratio]="130/375"
             [dfImage]="content.tutorialScreenBgImage"
             class="pos-absolute top-0 left-0 right-0 w-12 z-0">
        <!-- Add custom pagination container -->
        <div class="_swiperPagination"></div>

        <carousel class="_tutorialCarousel w-12 flex-grow p-t-5"
                  [pagination]="{
                        el: '._swiperPagination',
                        clickable: false,

                    }"
                  [slidesPerView]="1"
                  [allowTouchMove]="client.isCms"
                  (afterInit)="onAfterSwiperInit($event)">

            @for (step of slides; track step; let i = $index) {
            <ng-template swiperSlide>
                @switch (step.type) {
                @case (ESlideType.notification) {
                <div class="flex-column height-100">
                    <ng-container
                                  *ngTemplateOutlet="slideTpl; context: { slideContent: content, titleName: 'notificationTitle', descriptionName: 'notificationDescription', listName: 'notificationList' }"></ng-container>

                    <div class="w-12 center p-b-10 p-t p-l-10 p-r-10">
                        <action class="button w-12"
                                (click)="allowNotifications()"
                                [status]="allowNotificationsStatus">
                            <span *iCms="'notificationButtonCopy' of content"></span>
                        </action>
                        <result [status]="allowNotificationsStatus"></result>
                        <button class="button-inline-2 italic m-t-3"
                                (click)="nextSlide()">
                            <span *iCms="'notificationSkipButtonCopy' of content"></span>
                        </button>
                    </div>
                </div>
                }
                @case (ESlideType.simpleStep) {
                <div class="flex-column height-100">
                    <ng-container
                                  *ngTemplateOutlet="slideTpl; context: { slideContent: step.data, titleName: 'title', descriptionName: 'description', listName: 'list' }"></ng-container>
                    <div class="w-12 center p-b-10 p-t p-l-10 p-r-10">
                        <button class="button w-12"
                                (click)="nextSlide()">
                            <span *iCms="'continueButtonCopy' of content"></span>
                        </button>
                        <!-- skip button hidden for correct position between slides -->
                        <button class="button-inline-2 italic m-t-3 hidden">
                            <span *iCms="'skipButtonCopy' of content"></span>
                        </button>
                    </div>
                </div>
                }
                }
            </ng-template>
            }
        </carousel>
    </div>
    }
    @case (EStepType.login) {
    @if(isAccountForm) {
    <div class="p-b-6 height-100 overflow-y-auto bg-col-w z-2 pos-relative center">
        @if (content.loginImage) {
        <df-image-wrapper>
            <img [ratio]="content.loginImageRatio || '16/9'"
                 [dfImage]="content.loginImage" />
        </df-image-wrapper>
        }
        <div class="wrap"
             [ngClass]="content.loginImage ? 'p-t-6' : 'p-t-10'">
            <login-form-retail [content]="{useAlternativeVariant: false}"
                               [registerPageIsVisible]="isRegister"
                               (onSuccess)="close()"
                               class="left"></login-form-retail>
            <!-- [loyaltyDescription]="content.registerLoyaltyTermsDescription"
                           [loyaltyTitle]="content.registerLoyaltyTermsTitle" -->
            <button class="button-inline-2 italic m-t"
                    (click)="close()">
                {{'Continue as a guest' | translate}}
            </button>
        </div>
    </div>
    } @else {
    <div class="left-50 pos-absolute z-3"
         [style.top]="content.accountScreenLogoPosition + '%'"
         [style.transform]="'translate(-50%, -50%)'">
        <img [ratio]="content.mainLogoRatio"
             [dfImage]="content.mainLogo"
             [width]="250">
    </div>
    <div class="wrap pos-absolute left-0 right-0 bottom-0 p-b-20 center z-2">
        <button class="button w-12"
                (click)="openAccountForm()">{{'Sign In' | translate}}
        </button>
        <button class="button-1 w-12 m-t bg-col-t-s bg-col-t-m"
                (click)="openAccountForm(true)">{{'Create Account' | translate}}
        </button>
        <button class="button-inline-2 italic m-t"
                (click)="close()">
            {{'Continue as a guest' | translate}}
        </button>
    </div>
    }
    }
    }
    }

</div>


<ng-template #slideTpl
             let-slideContent="slideContent"
             let-titleName="titleName"
             let-descriptionName="descriptionName"
             let-listName="listName">
    <div class="flex-grow overflow-y-auto center">
        <div class="flex flex-middle p-r-9 p-l-9"
             style="min-height: 63px;">
            <div class="_decoration m-r-1"></div>
            <h3 class="h3 col-w flex-grow"
                *iCms="titleName of slideContent"></h3>
            <div class="_decoration m-l-1"></div>
        </div>
        <div class="m-t-1 p-t-5 bg-col-51 wrap">
            <p class="h4"
               *iCms="descriptionName of slideContent"></p>
            <div class="p-r-5 p-l-5 p-t-6 left">
                @for (item of slideContent[listName]; track item) {
                <div class="flex flex-top m-t">
                    @if (item.icon) {
                    <i [ngClass]="item.icon"
                       style="font-size: 24px;"
                       class="m-r-2"></i>
                    }
                    <p class="p2 col-11"
                       style="margin-top: 2px;"
                       *iCms="'text' of item"></p>
                </div>
                }
            </div>
        </div>
    </div>
</ng-template>
